import { Route } from "react-router-dom";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthConsumer } from "./AuthProvider";
import { SessionTimeout } from "./SessionTimeout";
import UserSessionContext, { IUserSessionContext } from "../../Services/Auth/UserSessionContext";
import { useState } from "react";
import { createPortal } from "react-dom";
import SessionExpirationModal from "./SessionExpirationModal";

export const AuthorizeRoute = ({ component, ...rest }: any) => {

    const [showSessionExpirationWarning, setShowSessionExpirationWarning] = useState(false);
    const userSessionContext : IUserSessionContext = {
        showSessionExpirationWarning,
        setShowSessionExpirationWarning
    };

    const renderFn = (Component :any) => (props: any) => (
        <AuthConsumer>
            {({ isAuthenticated, signinRedirect }) => {
                if (!!Component && isAuthenticated()) {
                    return <>
                        <UserSessionContext.Provider value={userSessionContext}>
                            <SessionTimeout/>
                            <Component {...props} />
                            {showSessionExpirationWarning && createPortal(<SessionExpirationModal showModal={showSessionExpirationWarning} setShowSessionExpirationWarning={setShowSessionExpirationWarning} />, document.body)}
                        </UserSessionContext.Provider>
                    </>;
                } else {
                    signinRedirect(null, window.location.pathname);
                    return <AbpnSpinner/>;
                }
            }}
        </AuthConsumer>
    );

    return <Route {...rest} render={renderFn(component)} />;
}